export default "__VITE_ASSET__B8WrBb8$__"